import _ from 'lodash';
import { Socket } from 'phoenix';

interface BackoffOptions {
  base: number;
  factor: number;
  max: number;
}

const exponentialBackoffWithJitter = (
  tries: number,
  { max, base, factor }: BackoffOptions,
) => {
  const exponentialBackoff = Math.min(max, base * factor ** tries);
  return Math.floor(_.random(0, exponentialBackoff));
};

const DEFAULT_BACKOFF_OPTIONS: BackoffOptions = {
  base: 1000,
  factor: 1.5,
  max: 120000,
};

interface Options {
  timeout?: number;
}

export default class SocketWithBackoffReconnect extends Socket {
  constructor(endPoint: string, { timeout }: Options = {}) {
    super(endPoint, {
      timeout,
      reconnectAfterMs: (tries) =>
        exponentialBackoffWithJitter(tries, DEFAULT_BACKOFF_OPTIONS),
    });

    window.addEventListener('online', () => this.reconnect());
    window.addEventListener('offline', () => this.disconnect());

    this.onClose((event) => {
      if (event.code === 1000) {
        this.scheduleReconnect();
      }
    });
  }

  scheduleReconnect() {
    // @ts-expect-error
    this.reconnectTimer.scheduleTimeout();
  }

  reconnect() {
    this.disconnect(() => {
      this.connect();
    });
  }
}
